import { AppType } from '@playback-rewards/shared-libraries'
import type {
  VerisoulCreateSessionDto,
  VerisoulCreateSessionResponseDto,
  VerisoulVerifySessionDto,
} from '@playback-rewards/shared-libraries'

import { axiosBackendInstanceV2 } from '../axiosInstance'

type CreateVerisoulSessionParams = Pick<VerisoulCreateSessionDto, 'userId'>
type VerifyVerisoulSessionParams = Pick<VerisoulVerifySessionDto, 'userId' | 'sessionId'>

type VerifyVerisoulSessionResponse = {
  message: string
}

export const createVerisoulSession = async ({
  userId,
}: CreateVerisoulSessionParams): Promise<VerisoulCreateSessionResponseDto> => {
  const payload: VerisoulCreateSessionDto = {
    appType: AppType.PLAYBACK_REWARDS,
    userId,
  }

  const response = await axiosBackendInstanceV2.post<VerisoulCreateSessionResponseDto>(
    '/api/v1/verisoul/create-session',
    payload
  )

  return response.data
}

export const verifyVerisoulSession = async ({
  userId,
  sessionId,
}: VerifyVerisoulSessionParams): Promise<VerifyVerisoulSessionResponse> => {
  const payload: VerisoulVerifySessionDto = {
    appType: AppType.PLAYBACK_REWARDS,
    userId,
    sessionId,
  }

  const response = await axiosBackendInstanceV2.post<VerifyVerisoulSessionResponse>(
    '/api/v1/verisoul/verify-session',
    payload
  )

  return response.data
}
